export default "__VITE_ASSET__dff96d9b__"